import * as React from 'react'

function SvgFacebook(props) {
    return (
        <svg viewBox='0 0 512 512' {...props}>
            <g data-name='Layer 2'>
                <g data-name='Layer 1'>
                    <rect width={512} height={512} rx={25} fill='#d7df22' />
                    <path
                        d='M353.5 512V314h66.75l10-77.5H353.5v-49.36c0-22.39 6.21-37.64 38.32-37.64h40.68V80.37c-7.08-.94-31.36-3.05-59.62-3.05-59 0-99.38 36-99.38 102.14v57H207V314h66.5v198z'
                        fill='#272424'
                    />
                </g>
            </g>
        </svg>
    )
}

export default SvgFacebook
